// extracted by mini-css-extract-plugin
export default {"root":"ui__shared__entry-version__field-version-list__root","fieldVersion":"ui__shared__entry-version__field-version-list__fieldVersion"};